module.exports = __webpack_public_path__ + "img/wz-8-2-4.8bfdfce7.jpg";